const BASE = '/api/v1/remotecheckin';

/**
 * - request wrapper
 * @param {*} method - type of request
 * @param {*} path - request path
 * @param {*} body - body of the request
 * @returns 
 */
const request = async (method, path, body) => {
    const opts = {
        method,
        credentials: 'include', // send prm_checkin_session cookie automatically
        headers: { 'Content-Type': 'application/json' },
    };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(`${BASE}${path}`, opts);
    if (res.status === 204) return null;
    const json = await res.json();
    if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
    return json;
};

// get the location from backend
export const getLocation = (locationCode) =>
    request('GET', `/location/${encodeURIComponent(locationCode)}`);

// Returns { bookingId, iata, state, locationId, locationTitle, flightType } or null (no active session)
export const getStatus = () => request('GET', '/status');

// Returns { bookingId, iata, state: 'created', isExisting? }
// flightType: 'departure' | 'arrival'
export const submitCheckin = async (locationCode, firstName, lastName, rawFlightNumber, departureDate, flightType, assistance) =>
    request('POST', '/submit', { locationCode, firstName, lastName, rawFlightNumber, departureDate, flightType, assistance: assistance || [] });

// option: 'not_collected' | 'no_longer_needed' | 'other'
export const reportIssue = (option, note) =>
    request('POST', '/report', { option, note: note || null });

export const cancelCheckin = () =>
    request('POST', '/cancel');

// Returns the merged task state for the session holder's check-in (cookie required).
// Merges session terminal flags (cancelled, expired) with standard task operational booleans
// (acknowledged, isAtLocation, active, completed) set by the staff app.
// Returns { acknowledged, isAtLocation, active, completed, cancelled, expired,
//           state, allocatedCcaId, employeeId }
export const getTaskState = () => request('GET', '/task-state');
